import '@babel/polyfill'
import Vue from 'vue'
import moment from 'moment-timezone'
import FastClick from 'fastclick'
import DomPortal from 'vue-dom-portal'
import { Toast } from 'mand-mobile'
import Validate from '@/lib/validator'
import filters from '@/lib/filters'
import http from '@/lib/axios'
import componentImporter from '@/lib/components-importer'
import mdImporter from '@/lib/md-importer'
import VueAnalytics from 'vue-analytics'
import VueGtm from 'vue-gtm'
import 'font-awesome/css/font-awesome.css'
import 'normalize.css/normalize.css'
import vConsole from 'vconsole'
import Raven from 'raven-js'
import RavenVue from 'raven-js/plugins/vue'
import VueClipboard from 'vue-clipboard2'
import customConsole from '@/lib/customConsole'
import vClickOutside from 'v-click-outside'
import config from '@/lib/config'

import App from './App'
import router from './router'
import store from './store'
import i18n from './lib/i18n'

// overwrite console function when 'production'
customConsole()

if ('ontouchstart' in window) {
  FastClick.attach(document.body)
}

Vue.config.productionTip = false

componentImporter(Vue)
mdImporter(Vue)

Vue.use(vClickOutside)
Vue.use(DomPortal)
Vue.use(filters)
Vue.use(Validate)
Vue.use(VueClipboard)

Vue.prototype.$http = http
Vue.prototype.$toast = Toast
Vue.prototype.$config = config
Vue.use(VueGtm, {
  id: 'GTM-PF9R9VD',
  enabled: true,
  vueRouter: router,
})
Vue.use(VueAnalytics, {
  id: 'UA-117508300-4',
  router,
  autoTracking: {
    exception: true,
    pageviewTemplate(route) {
      return {
        page: route.path,
        title: route.name,
        location: window.location.href,
      }
    },
  },
})
Vue.prototype.$track = function(data) {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push(data)
}

moment.tz.setDefault('Asia/Jakarta')
Vue.prototype.moment = moment

console.log(process.env)
// error tracking
if (process.env.VUE_APP_ERROR_TRACKING === 'yes') {
  Raven
    .config('https://b4d607da7bcf4dc286c54a1055b614de@sentry.kreditpintar.com/16')
    .addPlugin(RavenVue, Vue)
    .install()
}
// vConsole
if (process.env.VUE_APP_CONSOLE === 'yes') {
  // eslint-disable-next-line
  new vConsole()
}

window.vue = new Vue({
  i18n,
  router,
  store,
  render: h => h(App),
}).$mount('#app')
